import { render, staticRenderFns } from "./SignUpFranchiseStepTwo.vue?vue&type=template&id=5bd278d9&scoped=true&"
import script from "./SignUpFranchiseStepTwo.vue?vue&type=script&lang=js&"
export * from "./SignUpFranchiseStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./SignUpFranchiseStepTwo.vue?vue&type=style&index=0&id=5bd278d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd278d9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LogoWithTradeMark: require('/home/circleci/repo/components/LogoWithTradeMark.vue').default,VButton: require('/home/circleci/repo/components/VButton.vue').default})
